import { Button } from '@festina-life/ui/actions'
import { Alert, severityColorForegroundStyles } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'

import { useChangesetStateContext } from '../../context/changesetStateContext'
import { useUntilChangesetKeyValue } from '../../context/useUntilChangesetKeyValue'
import { useNavigationParams } from '../../system/useNavigationParams'

export const ChangesetStateWarning = () => {
  const translate = useTranslate()
  const { branch: branchName } = useNavigationParams()
  const { disabledChangesetKeys, onReset } = useChangesetStateContext()
  const untilChangesetKeyValue = useUntilChangesetKeyValue()
  const shouldShowWarning =
    !!disabledChangesetKeys.length || untilChangesetKeyValue // Even if no disabled changesets exist, if we're filtering by the topmost changeset we still show the warning for the sake of consistency

  return shouldShowWarning ? (
    <Alert
      severity="warning"
      action={
        <Button
          variant="discreet"
          className={severityColorForegroundStyles('warning', true)}
          onClick={onReset}
        >
          {translate('changesetState.warning.button')}
        </Button>
      }
      className="p-1! items-center! max-w-full!"
    >
      {translate('changesetState.warning.tooltip', {
        branchName: branchName ?? '',
      })}
    </Alert>
  ) : null
}
